const { getApiLanguage } = require('./language');
const { fetchJsonApi } = require('./abstract');

const versionPrefix = 'v1';

/**
 * @return Promise that return the user when fulfilled.
 */
function fetchUserQuotes(apiUrl) {
  return fetchJsonApi({
    apiUrl,
    method: 'GET',
    endpoint: `${versionPrefix}/user-quotes`,
    query: { lang: getApiLanguage() },
    expectedStatus: 200,
    description: 'Fetching user quotes',
  });
}

module.exports = {
  fetchUserQuotes,
};
